
/*
  Member form
 */
var mce, member;

member = {};

(function(member, $) {
  member.initForm = function($form) {
    return $(document).ready(function() {
      member.datePicker(document.getElementById('member_ozo_pr_date'));
      member.datePicker(document.getElementById('member_ozo_po_date'));
      member.toggleOzoAreas();
      return member.addressPreview();
    });
  };
  member.datePicker = function(element) {
    return new Pikaday({
      firstDay: 1,
      field: element,
      format: 'D.M.YYYY',
      minDate: new Date(),
      i18n: {
        previousMonth: 'Předchozí měsíc',
        nextMonth: 'Další měsíc',
        months: ['Leden', 'Únor', 'Březen', 'Duben', 'Květen', 'Červen', 'Červenec', 'Srpen', 'Září', 'Říjen', 'Listopad', 'Prosinec'],
        weekdays: ['Neděle', 'Pondělí', 'Úterý', 'Středa', 'Čtvrtek', 'Pátek', 'Sobota'],
        weekdaysShort: ['Ne', 'Po', 'Út', 'St', 'Čt', 'Pa', 'So']
      }
    });
  };
  member.addressPreview = function() {
    var $preview;
    $preview = $('#member_address_preview');
    return $('#member_address').on('keyup keypress blur change', function() {
      return $preview.attr('href', 'http://maps.google.com/maps/place/' + $(this).val());
    });
  };
  return member.toggleOzoAreas = function() {
    var toggle;
    toggle = function() {
      var $area, checked;
      checked = this.checked;
      $area = $($(this).data('toggle'));
      $area.toggle(checked);
      return $('input[type=text]', $area).each(function() {
        return $(this).prop('required', checked);
      });
    };
    $('input[type=checkbox][data-toggle]').change(toggle);
    return $('input[type=checkbox][data-toggle]').each(toggle);
  };
})(member, jQuery);


/*
  TinyMCE Limit content
 */

mce = {};

(function(mce, $) {
  mce.setup = function(ed) {
    return mce.limitTeenyContent(ed);
  };
  mce.getStats = function(id) {
    var body, text;
    body = tinymce.get(id).getBody();
    text = tinymce.trim(body.innerText || body.textContent);
    return {
      chars: text.length,
      words: text.split(/[\w\u2019\'-]+/).length
    };
  };
  return mce.limitTeenyContent = function(ed) {
    var $limit, limit;
    $limit = $('#' + ed.id + '-limit');
    limit = $limit.text();
    ed.on('init blur change', function(e) {
      var length;
      length = mce.getStats(ed.id).chars;
      return $limit.text(limit - length);
    });
    return ed.on('KeyDown', function(e) {
      var ctrlDown, length;
      ctrlDown = e.ctrlKey || e.metaKey;
      length = mce.getStats(ed.id).chars;
      $limit.text(limit - length);
      $limit.parent().toggleClass("overflow", limit - length < 0);
      if (length >= limit && !ctrlDown && e.keyCode !== 8 && e.keyCode !== 9 && e.keyCode !== 46 && e.keyCode !== 36 && e.keyCode !== 35 && e.keyCode !== 37 && e.keyCode !== 38 && e.keyCode !== 39 && e.keyCode !== 40) {
        return tinymce.dom.Event.cancel(e);
      }
    });
  };
})(mce, jQuery);
